export const buttonTags = [
  {
    id: 0,
    name: "AI Agents",
    path: "ai-agents",
  },
  {
  	id: 1,
  	name: "Automated CRM",
  	path: "automated-crm",
  },
  {
    id: 2,
    name: "Message and Calls",
    path: "messages-and-calls",
  },
  {
    id: 3,
    name: "Project Management",
    path: "project-management",
  },
  {
    id: 4,
    name: "Ticket Management",
    path: "ticket-management",
  },
  {
    id: 5,
    name: "Getting Started",
    path: "getting-started",
  },
];
